export default class JsxBindClassMetadata {

    /**
     * bind ref -> properties
     * @protected
     */
    private _bindsSingle: Map<string, string[]> = new Map<string, string[]>();
    private _bindsArr: Map<string, string[]> = new Map<string, string[]>();

    constructor() {
    }

    public addSingle(ref: string, property: string){
        if(this._bindsSingle.has(ref)){
            this._bindsSingle.get(ref).push(property);
            return;
        }

        this._bindsSingle.set(ref, [property]);
    }

    public addArr(ref: string, property: string){
        if(this._bindsArr.has(ref)){
            this._bindsArr.get(ref).push(property);
            return;
        }

        this._bindsArr.set(ref, [property]);
    }

    public findSingleBind(ref: string){
        if(this._bindsSingle.has(ref)){
            return this._bindsSingle.get(ref);
        }
        return [];
    }

    public findArrBind(ref: string){
        if(this._bindsArr.has(ref)){
            return this._bindsArr.get(ref);
        }
        return [];
    }

    public clearProperties(obj:any){

        this._bindsSingle.forEach((props) => {
            props.forEach(p => {
                obj[p] = null
            });
        });

        this._bindsArr.forEach((props) => {
            props.forEach(p => {
                obj[p] = [];
            })
        });

    }

    public fillProperties(obj:any, ref:string, elem: any){

        this.findSingleBind(ref).forEach((prop) => {
            obj[prop] = elem;
        });

        this.findArrBind(ref).forEach((prop) => {
            if(null == obj[prop]){
                obj[prop] = [];
            }
            obj[prop].push(elem);
        });

    }

    get bindsSingle(): Map<string, string[]> {
        return this._bindsSingle;
    }
}